import { ContactUsMap } from "./contactUsAction";

const initialState = {
  isLoading: false,
  ContactList: {},
  refreshContactList: true,
  searchBy: "",
  countries: [],
  searchText: "",
  pageNameList: [],
  contactNameList: [], //created new variable for dashboard use
  skip: 0,
  limit: 50,
  selectedContact: {},
  audioType: "all",
  leadType: "all",
  callOutcomeFilter: "all",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ContactUsMap.GET_ALL_CONTACT_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ContactUsMap.GET_ALL_CONTACT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ContactList: action.payload,
        refreshContactList: false,
      };
    }
    case ContactUsMap.GET_ALL_CONTACT_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshContactList: false,
      };
    }

    case ContactUsMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
        refreshContactList: true,
      };
    }
    case ContactUsMap.SET_CONTACT_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshContactList: true,
      };
    }
    case ContactUsMap.SET_LIMIT: {
      return {
        ...state,
        limit: action.payload,
        skip: 0,
        refreshContactList: true,
      };
    }
    case ContactUsMap.GET_CONTACT_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ContactUsMap.GET_CONTACT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ContactList: action.payload,
        refreshContactList: false,
      };
    }
    case ContactUsMap.GET_CONTACT_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshContactList: false,
      };
    }
    case ContactUsMap.GET_PAGE_NAME_LIST_SUCCESS: {
      return {
        ...state,
        pageNameList: action.payload,
        contactNameList: action.payload,
      };
    }
    case ContactUsMap.SET_AUDIO_TYPE: {
      return {
        ...state,
        audioType: action.payload,
        refreshContactList: true,
      };
    }
    case ContactUsMap.SET_LEAD_TYPE: {
      return {
        ...state,
        leadType: action.payload,
        skip: 0, // Reset pagination when filter changes
        refreshContactList: true,
      };
    }
    case ContactUsMap.SET_CALL_OUTCOME_FILTER: {
      return {
        ...state,
        callOutcomeFilter: action.payload,
        skip: 0,
        refreshContactList: true,
      };
    }
    case ContactUsMap.UPDATE_LEAD_TYPE_IN_LIST: {
      const { id, leadType } = action.payload;
      if (!state.ContactList || !Array.isArray(state.ContactList.records)) {
        return state;
      }
      return {
        ...state,
        ContactList: {
          ...state.ContactList,
          records: state.ContactList.records.map((record) =>
            record._id === id ? { ...record, leadType } : record,
          ),
        },
      };
    }
    default:
      return { ...state };
  }
};
